import { cn } from '@/src/utils';
import React, {
  PropsWithChildren,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';

function BottomFixedContainer({ children }: PropsWithChildren) {
  const navRef = useRef<HTMLElement | null>(null);
  const [right, setRight] = useState<number>();

  useLayoutEffect(() => {
    const nav = document.querySelector('nav');
    navRef.current = nav;
    setRight(navRef.current?.getBoundingClientRect().right);
  }, []);

  useEffect(() => {
    const listener = () => {
      setRight(navRef.current?.getBoundingClientRect().right);
    };
    window?.addEventListener('resize', listener);
    window.addEventListener('scroll', listener);

    return () => {
      window.removeEventListener('resize', listener);
      window.removeEventListener('scroll', listener);
    };
  }, []);

  return (
    <footer
      id="bottom-fixed-footer"
      className={cn(
        'fixed bottom-0 z-bottomFixed m-0 w-[calc(100%-240px)] min-w-[1010px]  bg-white px-10 py-4 shadow-[0_4px_15px_0px_rgba(26,29,32,0.03)]',
      )}
      style={{
        left: `${right}px`,
      }}
    >
      {children}
    </footer>
  );
}

export default BottomFixedContainer;
